<ng-template #allPresetsView>
    @if (presets) {
        <div class="presets">
            <input
                type="text"
                [placeholder]="'browse.searchPlaceholder' | t"
                class="form-control mb-2"
                [(ngModel)]="scopeFilter"
                (debounce-input-event)="filterPresets()"
                inputTooltip
            />
            <ngx-masonry [options]="{ percentPosition: true, gutter: 10 }">
                @for (preset of scopedPresets; track preset) {
                    <div ngxMasonryItem class="masonry-item">
                        <div
                            class="card"
                            [class.border-primary]="currentPreset && preset.id == currentPreset.id"
                            [attr.data-uiid]="'preset-card-' + preset.name"
                        >
                            <div class="card-body">
                                <h5 class="card-title">
                                    <cerrix-icon-viewer [icon]="preset.icon"></cerrix-icon-viewer>
                                    {{ preset.name }}
                                </h5>
                                <p class="card-text text-muted" [matTooltip]="preset.description">
                                    {{ preset.description }}
                                </p>
                                <footer class="blockquote-footer text-muted">
                                    {{ preset.createdBy }} ({{ preset.updatedOn | dateTimeFormat }})
                                </footer>
                                <div class="card-actions d-inline-flex w-100 mt-2">
                                    <button
                                        class="button"
                                        data-uiid="preset-card-open"
                                        (click)="setPreset(preset)"
                                        [matTooltip]="'browse.openPreset' | t"
                                        [disabled]="currentPreset && preset.id == currentPreset.id"
                                    >
                                        <i class="fad fa-external-link fa-fw"></i>
                                    </button>
                                    <button
                                        class="button"
                                        (click)="OpenInfoDialog(preset)"
                                        [matTooltip]="'browse.presetInformation' | t"
                                    >
                                        <i class="fas fa-info"></i>
                                    </button>
                                    <button
                                        class="button"
                                        (click)="preset.api.setDefault()"
                                        [matTooltip]="'browse.defaultPreset' | t"
                                    >
                                        <i
                                            class="{{
                                                preset.isDefault ? 'fas primary-color' : 'far'
                                            }} fa-house fa-fw"
                                        ></i>
                                    </button>
                                    <button
                                        class="button"
                                        data-uiid="preset-card-favorite"
                                        [disabled]="preset.isDefault"
                                        (click)="preset.api.toggleFavorite()"
                                        [matTooltip]="'browse.favouritePreset' | t"
                                    >
                                        <i
                                            class="{{
                                                preset.isFavorite ? 'fas orange' : 'far'
                                            }} fa-star fa-fw"
                                        ></i>
                                    </button>
                                    @if (usePresetHyperlink) {
                                        <button
                                            class="button"
                                            (click)="preset.api.copyUrlToClipboard()"
                                            [matTooltip]="'browse.copyLink' | t"
                                        >
                                            <i class="far fa-copy fa-fw"></i>
                                        </button>
                                    }
                                    @if (preset.isOwner && !preset.isSystemDefault) {
                                        <button
                                            class="button delete-button"
                                            data-uiid="preset-card-delete"
                                            (click)="preset.api.delete()"
                                            [matTooltip]="'browse.deletePreset' | t"
                                        >
                                            <i class="fas fa-trash fa-fw"></i>
                                        </button>
                                    }
                                    @if (permissions.canSetSystemDefault) {
                                        <button
                                            class="button ms-auto"
                                            (click)="preset.api.setSystemDefault()"
                                            [matTooltip]="'browse.toggleSystemDefault' | t"
                                            [disabled]="!preset.isPublic && !preset.isPredefined"
                                        >
                                            <i
                                                class="{{
                                                    preset.isSystemDefault
                                                        ? 'fas primary-color'
                                                        : 'far'
                                                }} fa-house-lock fa-fw"
                                            ></i>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </ngx-masonry>
        </div>
    } @else {
        <div class="fancy-loader"></div>
    }
</ng-template>
